import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { PrefillResumeEvents } from 'builder/modules/constants'
import { useI18n } from 'builder/hooks/useI18n'
import { OptionsContainer, CloseIconWrapper, CloseIcon, Title, SubTitle, Header } from './styles'
import OptionCards from './OptionCards'
import { Props } from './types'

export const OptionsViewV3 = ({ onClose }: Props) => {
  const { i18n } = useI18n()

  useEffect(() => {
    trackInternalEvent(PrefillResumeEvents.seeStartScreen)
  }, [])

  const onStartScreenClose = () => {
    trackInternalEvent(PrefillResumeEvents.clickCrossButtonStartScreen)
    onClose()
  }

  return (
    <OptionsContainer>
      <CloseIconWrapper onClick={onStartScreenClose}>
        <CloseIcon />
      </CloseIconWrapper>
      <Header>
        <Title>{i18n.t('builder.prefill_resume.start_title')}</Title>
        <SubTitle>{i18n.t('builder.prefill_resume.start_subtitle')}</SubTitle>
      </Header>
      <OptionCards {...{ onClose }} />
    </OptionsContainer>
  )
}
